import React from "react";

import { Button, Card, Col, message, Popconfirm, Row, Table } from "antd";

import {
    IotDeviceService
} from "../../services";

import IotDeviceEditor from "./iot-device-editor";

class IotDeviceManager extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addNewIotDevice: false,
            editIotDevice: false,
            loading: true,
            iotDevices: []
        }

    }

    async componentDidMount() {

        try{
            const res = await IotDeviceService.getDevices();

            this.setState({
                loading: false,
                iotDevices: res.data.iotDevices
            });
    
        } catch( e ){
            message.error(e.toString());
            throw e;
        }

    }

    render() {
        return (
            <div>
                { this.renderAddNewIotDeviceModal()}
                { this.renderEditIotDeviceModal()}

                <Card>

                    <Row gutter={16} type="flex">
                        <Col>
                            <h2>Iot Devices</h2>
                        </Col>

                        <Col>
                            <Button onClick={this.onClickAddNewDevice} type="primary" icon="plus">
                                New Device
                            </Button>
                        </Col>
                    </Row>

                    {/* list all iot devices */}
                    <Table
                        loading={this.state.loading}
                        rowKey="_id"
                        columns={this.getTableColumns()}
                        dataSource={this.state.iotDevices} />
                </Card>
            </div>
        )
    }

    renderAddNewIotDeviceModal = () => {

        if (!this.state.addNewIotDevice) {
            return null;
        }

        return (
            <IotDeviceEditor
                onCancel={this.onCloseAddNewDeviceModal}
                onConfirm={this.onAddNewDevice}
            />
        );

    }

    renderEditIotDeviceModal = () => {

        if (!this.state.editIotDevice) {
            return null;
        }

        return (
            <IotDeviceEditor
                iotDevice={this.state.editIotDeviceData}
                onCancel={this.onCloseEditDeviceModal}
                onConfirm={this.onEditDevice}
            />
        )

    }

    getTableColumns = () => {

        return [
            {
                title: "Device Type",
                key: "deviceType",
                dataIndex: "deviceType"
            },
            {
                title: "Device Name",
                key: "deviceName",
                dataIndex: "deviceName",
                render: (text, record, index) => {
                    return (
                        <a href={`/iot-devices/${record.deviceType.toLowerCase()}/${record.deviceName}`}>
                            {record.deviceName}
                        </a>
                    );
                }
            },
            {
                title: "Enterprise Id",
                key: "enterpriseId",
                dataIndex: "enterpriseId"
            },
            {
                title: "Actions",
                key: "actions",
                render: (text, record, index) => {
                    return (
                        <div>

                            <Row type="flex" gutter={8}>
                                <Col>
                                    <Button
                                        onClick={() => this.onClickEditDevice(record)}
                                        type="primary">
                                        Edit
                                    </Button>
                                </Col>

                                <Col>
                                    <Popconfirm
                                        title="Are you sure? This can't be undone."
                                        onConfirm={() => this.onDeleteDevice(record._id)}>
                                        <Button
                                            type="danger">
                                            Delete
                                        </Button>
                                    </Popconfirm>
                                </Col>
                            </Row>

                        </div>
                    );
                }
            }
        ];

    }

    onAddNewDevice = async (iotDeviceData) => {

        try {

            let res = await IotDeviceService.postAddNewDevice(iotDeviceData);

            message.success("Iot Device Added");

            this.setState({
                addNewIotDevice: false,
                iotDevices: [
                    ...this.state.iotDevices,
                    res.data.iotDevice
                ]
            });

        } catch (e) {
            message.error(e.toString());
            message.error(e.response.data.errors);
        }

    }

    onClickAddNewDevice = () => {

        this.setState({
            addNewIotDevice: true
        });

    }

    onClickEditDevice = (iotDevice) => {

        this.setState({
            editIotDevice: true,
            editIotDeviceData: iotDevice
        });

    }

    onCloseAddNewDeviceModal = () => {

        this.setState({
            addNewIotDevice: false
        });

    }

    onCloseEditDeviceModal = () => {
        this.setState({
            editIotDevice: false,
            editIotDeviceData: {}
        })
    }

    onDeleteDevice = async (iotDeviceId) => {

        try {

            await IotDeviceService.deleteIotDevice(iotDeviceId)
            message.success("IOT Device Deleted");

            this.setState({
                iotDevices: this.state.iotDevices.filter(
                    _iotDevice => {
                        return _iotDevice._id !== iotDeviceId
                    }
                )
            })

        } catch (e) {
            message.error(e.toString());
        }

    }

    onEditDevice = async (updateIotDeviceData) => {

        try {

            let res = await IotDeviceService.postEditIotDevice(updateIotDeviceData)
            message.success("Iot Device Edited");
            this.onCloseEditDeviceModal();

            this.setState({
                iotDevices: this.state.iotDevices.map(
                    iotDevice => {

                        if (iotDevice._id != updateIotDeviceData._id) {
                            return iotDevice;
                        }

                        return res.data.iotDevice;
                    }
                )
            });

        } catch (e) {
            message.error(e.toString());
        }

    }

}

export default IotDeviceManager;


// WEBPACK FOOTER //
// ./src/components/iot-devices/index.js